import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  PopupLoader: {
    '&__modal-container': {
      height: '100vh',
      left: '0',
      position: 'fixed',
      top: '0',
      width: '100%',
      zIndex: '2000',
      '&__loader': {
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.80)',
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        width: '100%',
      },
    },
  },
});

export { useStyles };
